/* eslint-disable max-len */
import { BoardMembersFormViewModel } from '../../../types/BoardMembersFormViewModel';
import { SelectOption } from '../../../types/SelectOption'; // Ensure this path is correct
import BoardMembersPrimaryInformationPanel from './BoardMembersPrimaryInformationPanel';
import { DataEntryMode } from '../../../types/DataEntryMode';
import BoardMembersHomeAddressPanel from './BoardMembersHomeAddressPanel';


interface BoardMembersInformationProps {
  dataEntryMode: DataEntryMode;
  formViewModel: BoardMembersFormViewModel;
  allowEdit?: boolean;
  stateOptions: SelectOption[];
}

const BoardMembers_Layout: React.FC<
  BoardMembersInformationProps
> = ({ dataEntryMode, formViewModel, allowEdit, stateOptions }) => {

  return (
    <>
      <BoardMembersPrimaryInformationPanel 
        dataEntryMode={dataEntryMode} 
        formViewModel={formViewModel} 
        allowEdit={allowEdit}
      />
      <BoardMembersHomeAddressPanel
        dataEntryMode={dataEntryMode} 
        formViewModel={formViewModel} 
        allowEdit={allowEdit}
        stateOptions={stateOptions}
      />
    </>
  );
};

export default BoardMembers_Layout;
